import { render } from "./CourseBookings.vue?vue&type=template&id=da80795a"
import script from "./CourseBookings.vue?vue&type=script&lang=js"
export * from "./CourseBookings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__